package com.rainbowclubs.rainbow.domain.use_cases.login

import com.rainbowclubs.rainbow.data.cache.ClubCache

class IsSelectedClubCached(
    private val clubCache: ClubCache
) {
    suspend operator fun invoke(): Result<Boolean> = try {
        Result.success(clubCache.hasSelectedClub())
    } catch (e: Exception) {
        Result.failure(e)
    }
}
